<template>
    <div class="web-header">

        <el-row class="am-padding-xs">
            <el-col :span="6">
                <router-link to="/"><img style="margin-top:8px;" src="../../assets/images/logo.png" alt=""></router-link>
            </el-col>
            <el-col :span="15" class="am-text-center am-padding-top-xs">
                <img src="../../assets/images/234.png"  alt="">
            </el-col>
            <el-col :span="3" class="am-text-right">
                <img src="../../assets/images/logo.jpg"    height="80" alt="">
            </el-col>
        </el-row>
        <web-menu></web-menu>
       
    </div>
</template>

<script>
import slider from '@/components/slider'
import WebMenu from './WebMenu'
export default {
    components:{WebMenu,slider},
    data(){
        return {
            banner:[]
        }
    },
    created(){
          this.getList({
                typeId: 'port42',
                rowNum: '8',
                imgFlg:1,
            }).then(result => {
                this.banner = result
            })
    }
}
</script>

<style lang="scss">
.web-header{
    margin-top: 0px;
    background-color: rgba(255, 255, 255, .5);
    margin-bottom: 20px;
    
}
</style>
